import Tippy from '@tippy.js/react';

import { Icon } from '../../../UI';
import { ProfitLoss } from '../../../ProfitLoss';

import {
  computePercentage,
  formatCurrency,
  getSymbol,
} from '../../../../helpers/functions';

import { IStrategy } from '../../../../types/model';

export const HorizontalMarker = ({
  className = 'left-1/2',
  tooltipContent,
}: {
  className?: string;
  tooltipContent?: JSX.Element | string;
}) => (
  <Tippy
    content={<div className="p-2">{tooltipContent}</div>}
    flip
    className="tippy-tooltip"
  >
    <div
      className={`
        w-px
        z-10
        bg-grey-10
        dark:bg-grey-80
        h-6
        absolute
        top-1/2
        -translate-y-1/2
        -translate-x-1/2
        ${className}
      `}
      style={{ transform: 'translateY(-50%)' }}
    >
      <div className="p-4 w-1 h-1 relative -left-3" />
    </div>
  </Tippy>
);

export const TriangleMarker = ({
  entryPrice,
  targetPrice,
  currency,
  leftOffset,
  withLabel = false,
}: {
  entryPrice: number;
  targetPrice: number;
  currency: IStrategy['currency'];
  leftOffset: number;
  withLabel?: boolean;
}) => {
  // console.log({ leftOffset });
  return (
    <Tippy
      content={
        <div className="p-2 flex justify-between items-center">
          <ProfitLoss
            isRow={false}
            percentage={computePercentage(entryPrice!, targetPrice, 100)}
            performancePosition="percentage"
            prefixPercentage={entryPrice < targetPrice ? '+' : '-'}
            suffixPercentage="%"
            symbol={getSymbol(currency)}
            valueClassName={'text-white'}
            value={targetPrice}
          />
        </div>
      }
    >
      <div
        className="absolute top-full z-10"
        style={{
          ...(targetPrice < entryPrice
            ? { left: `${leftOffset}%` }
            : { right: `${leftOffset}%` }),
          marginTop: '-4px',
        }}
      >
        <Icon
          svgName="marker"
          className="h-3 w-3 cursor-pointer"
          color={targetPrice < entryPrice ? 'negative' : 'positive'}
        />
        {withLabel && (
          <div
            className="text-grey-70 text-xs absolute"
            style={{ transform: 'translateX(-50%)' }}
          >
            {formatCurrency(targetPrice, currency)}
          </div>
        )}
      </div>
    </Tippy>
  );
};
